export default "__VITE_ASSET__DBb3fpmY__"